import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/iconfont/iconfont'
import SvgIcon from '@/components/svgicon/svgIcon.vue'
import BackgroundImage from './components/sakura/sakura.vue'
import HeaderModule from './components/header/headerModule.vue'
import FooterModule from './components/footer/footerModule.vue'
import BackTop from './components/backTop/backTop.vue'
import Particles from "@tsparticles/vue3"
import { loadSlim } from "@tsparticles/slim"
import BackGround from './components/background/starryBackground.vue'

const app = createApp(App);
app.use(ElementPlus);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.component('BackgroundImage',BackgroundImage)
app.component('HeaderModule',HeaderModule)
app.component('FooterModule',FooterModule)
app.component('BackTop',BackTop)
app.component('BackGround',BackGround)
app.component('SvgIcon',SvgIcon)
app.use(store).use(router).mount('#app')
app.use(Particles, {
    init: async engine => {
      await loadSlim(engine);
    },
  })